import { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DataTable from 'react-data-table-component';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Format from '../../../Services/Format';
import { FaEye } from 'react-icons/fa';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Loading from '../../Loading/Loading';

import api from '../../../Services/api';
import Globals from '../../../Globals.json';
import DateUtils from '../../../Services/DateUtils';
import { IListVendas } from '../../../Pages/Cadastro/CadListagemVendas';
import LayoutFilter from '../../data/LayoutFilter';
import ReactSelect from '../../data/reactSelect';
import { InputDefault } from '../../data/inputDefault';
import LayoutTable from '../../data/LayoutTable';
import tableStyleDefault from '../../../Services/tableStyleDefault';
import { NoData } from '../../noData';
import CustomLoader from '../../data/customLoader';
import { useAppSelector } from '../../../redux/store';
import * as S from './styled';
import { notifyError } from '../../notify/notify-component';
import tableStyleDefaultFinancial from "../../../Services/tableStyleDefaultFinancial";
import { useQueryFetchPages } from "../../../apiQuery/useQueryFetchPages";
import SaleDetailView from './SaleDetailView';
import { IVendas } from './interfaces/IVendas';
import { showSale } from '../../../Services/sales-service';


export default function ListaVendas({
  title,
  OnAddNewCli,
  OnAddNewVendas,
  onEditItem,
}: IListVendas) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);

  const [tableList, setTableList] = useState<any[]>([]);

  const [shift, setShift] = useState<string>('');
  const [receiptId, setReceiptId] = useState<string>('');
  const [netValue, setNetValue] = useState<string>('');
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState<number>(0);
  const [type_date, setTypeDate] = useState<number>(0);
  const [lastPage, setLastPage] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [type, setType] = useState<string>('');
  const [vendor_id, setVendorId] = useState<string>('');
  const [movementType, setMovementType] = useState<string>('');
  const [operationType, setOperationType] = useState<string>('');
  const [startDate, setStartDate] = useState<string>(
    Format.firstDate('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState<string>(
    Format.date(DateUtils.endOfMonth(), 'YYYY-MM-DD')
  );
  const [movementStartDate, setMovementStartDate] = useState<string>(
    Format.firstDate('YYYY-MM-DD')
  );
  const [movementEndDate, setMovementEndDate] = useState<string>(
    Format.date(DateUtils.endOfMonth(), 'YYYY-MM-DD')
  );
  const [origin, setOrigin] = useState<string>('');
  const [status, setStatus] = useState<string>('');

  const listTurn = [
    { value: "", label: 'Todos' },
    { value: "1", label: 'Turno 1' },
    { value: "2", label: 'Turno 2' },
  ];

  const listdate = [
    { value: 0, label: 'Todos' },
    { value: 1, label: 'Data Criação' },
  ];

  const oOperationType = [
    {
      id: '',
      value: 'Todos',
    },
    {
      id: 'entrada',
      value: 'Entrada',
    },
    {
      id: 'saida',
      value: 'Saída',
    },
  ];

  const [listOperationType, setListOperationType] = useState<Array<any>>([]);
  const [page, setPage] = useState(1);

  const [validDateIni, setValidDateIni] = useState<boolean>(false);
  const [validDateEnd, setValidDateEnd] = useState<boolean>(false);
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [loadingVendas, setLoadingVendas] = useState<boolean>(false);

  const [showDetalhe, setShowDetalhe] = useState<boolean>(false);
  const [vendaDetalhe, setVendaDetalhe] = useState<IVendas | undefined>(undefined);
  const [loadingDetalhe, setLoadingDetalhe] = useState<boolean>(false);

  const {
    data: vendas,
    isLoading: isLoadingVendas,
    refetch: refetchVendas,
  } = useQueryFetchPages<any>(
    ['sales', shift, receiptId, netValue, type, vendor_id, movementType, operationType, origin, status, startDate, endDate, movementStartDate, movementEndDate],
    `${Globals.api.sales}`,
    {
      page: page,
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        // Mais recentes primeiro; `id` desempata vendas com o mesmo horário.
        sort: '-created_at,-id',
        ...(shift &&{ 'filter[shift]': shift }),
        ...(receiptId && { 'filter[receipt_type_id]': receiptId }),
        ...(netValue && { 'filter[net_value]': netValue }),
        ...(type && { 'filter[type]': type }),
        ...(vendor_id && { 'filter[vendor_id]': vendor_id }),
        ...(movementType && { 'filter[stock_movement_type_id]': movementType }),
        ...(operationType && { 'filter[operation]': operationType }),
        ...(origin && { 'filter[origin]': origin }),
        ...(status && { 'filter[situation_id]': status }),
        ...(type_date === 1 && { 'filter[created_at]': movementStartDate }),
        ...(type_date === 1 && { 'filter[created_at_end]': movementEndDate }),
        ...(type_date === 2 && { 'filter[starts_at]': startDate }),
        ...(type_date === 2 && { 'filter[ends_at]': endDate }),
      },
    }
  );

  const [filter, setFilter] = useState<string>('');

  const isLater = (start: string, end: string) => {
    return start > end;
  };

  const handleShow = (row: any) => {
    setShowDetalhe(true);

    if (row.relationships) {
      setVendaDetalhe(row);
      return;
    }

    setVendaDetalhe(undefined);
    setLoadingDetalhe(true);
    showSale(row.uuid)
      .then((response) => {
        setVendaDetalhe(response.data?.data ?? response.data);
      })
      .catch((error) => {
        notifyError(error);
        setShowDetalhe(false);
      })
      .finally(() => {
        setLoadingDetalhe(false);
      });
  };

  const handleCloseDetalhe = () => {
    setShowDetalhe(false);
    setVendaDetalhe(undefined);
  };

  const handleDateStart = async (date: string) => {
    if (!date) return;
    if (date.length !== 10) {
      setValidDateIni(false);
      return;
    }
    if (type_date === 2) {
      setStartDate(date);
    } else {
      setMovementStartDate(date);
    }
    const dateValid = isLater(date, endDate);
    setValidDateIni(dateValid);
    if (dateValid) {
      return;
    }
  };

  const onClickOpenFilter = () => {
    setOpenFilter(!openFilter);
  };

  const handleDateEnd = async (date: string) => {
    if (!date) return;
    if (date.length !== 10) {
      setValidDateIni(false);
      return;
    }
    if (type_date === 2) {
      setEndDate(date);
    } else {
      setMovementEndDate(date);
    }
    const dateValid = isLater(startDate, date);
    setValidDateEnd(dateValid);

    if (dateValid) {
      return;
    }
  };

  const clearFields = () => {
    setShift('');
    setReceiptId('');
    setNetValue('');
    setType('');
    setOrigin('');
    setOperationType('');
    setVendorId('');
    setMovementType('');
    setStatus('');
    setStartDate(Format.date(new Date(), 'YYYY-MM-DD'));
    setEndDate(Format.date(DateUtils.endOfMonth(), 'YYYY-MM-DD'));
    setMovementStartDate(Format.date(new Date(), 'YYYY-MM-DD'));
    setMovementEndDate(Format.date(DateUtils.endOfMonth(), 'YYYY-MM-DD'));
    setFilter('');
    setTypeDate(0);
    //getMovement(1);
  };

  /*
  const handlePageChange = (page: any) => {
    getMovement(page, filter);
  };

  const createFilter = (filterList: Array<string>): string => {
    let filter = '';
    for (let i = 0; i < filterList.length; i++) {
      if (i >= 1) {
        filter += '&';
      }
      filter += `filter${filterList[i]}`;
    }
    return filter;
  };
  const handleSearchList = () => {
    if (validDateIni || validDateEnd) return;
    const filterList = [];
    if (type !== '') filterList.push(`[type]=${type}`);
    if (shift !== '') filterList.push(`[shift]=${shift}`);
    if (receiptId !== '') filterList.push(`[receipt_type_id]=${receiptId}`);
    if (netValue !== '') filterList.push(`[net_value]=${netValue}`);
    if (vendor_id) filterList.push(`[vendor_id]=${vendor_id}`);
    if (movementType)
      filterList.push(`[stock_movement_type_id]=${movementType}`);
    if (operationType) filterList.push(`[operation]=${operationType}`);
    if (origin !== '') filterList.push(`[origin]=${origin}`);
    if (status !== '') filterList.push(`[situation_id]=${status}`);
    if (type_date === 1) {
      filterList.push(`[created_at]=${movementStartDate}`);
      filterList.push(`[created_at_end]=${movementEndDate}`);
    }
    if (type_date === 2) {
      filterList.push(`[starts_at]=${startDate}`);
      filterList.push(`[ends_at]=${endDate}`);
    }
    if (filterList.length > 0) {
      const filter = createFilter(filterList);
      if (filter !== '') {
        getMovement(1, filter);
        setFilter(filter);
      }
      return;
    }
    getMovement(1);
  };
*/
  const formatCreatedAt = (createdAt: string | Date, pattern: string) => {
    if (createdAt instanceof Date) {
      return Format.date(createdAt, pattern);
    }
    if (typeof createdAt === 'string') {
      return Format.date(new Date(createdAt), pattern);
    }
    return String(createdAt ?? '');
  };

  const columns = [
    {
      name: 'Data',
      center: true,
      grow: 0.2,
      selector: (row: { created_at: string | Date }) => {
        if (row.created_at === 'Total') {
          return row.created_at;
        }
        return formatCreatedAt(row.created_at, 'DD/MM/YYYY');
      },
    },
    {
      name: 'Hora',
      center: true,
      grow: 0.2,
      selector: (row: { created_at: string | Date }) => {
        if (row.created_at === 'Total') {
          return '';
        }
        return formatCreatedAt(row.created_at, 'HH:mm');
      },
    },

    {
      name: 'Turno',
      center: true,
      grow: 0.2,
      selector: (row: any) => row.shift ? "turno " + row.shift : "",
    },
    {
      name: 'Operação',
      center: true,
      grow: 0.2,
      selector: (row: any) => row.operation,
    },
    {
      name: 'Recebimento',
      center: true,
      grow: 0.2,
      sortable: true,
      selector: (row: any) => row.relationships?.paymentType?.description ?? '',
    },
    {
      name: 'Autoatendimento',
      center: true,
      grow: 0.2,
      selector: (row: any) => {

        if (row.self_service) {
          return 'sim'
        }

        if (row.self_service === false) {
          return 'Não'
        }

        return row.self_service
      },
    },
    {
      name: 'Valor Liquido',
      center: true,
      sortable: true,
      grow: 0.2,
      selector: (row: any) =>
        row.net_value?.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    {
      name: 'Serviço',
      center: true,
      sortable: true,
      grow: 0.2,
      selector: (row: any) =>
        row.service_value?.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    {
      name: 'Valor Bruto',
      center: true,
      grow: 0.2,
      sortable: true,
      selector: (row: any) =>
        row.gross_value?.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },

    {
      name: 'Ação',
      center: true,
      grow: 0.2,
      cell: (row: any) => {

        if (row.id) {
          return (
            <OverlayTrigger
              overlay={<Tooltip id="tooltip-disabled">Detalhar Venda</Tooltip>}
            >
              <span className="d-inline-block">
                <Button
                  onClick={() => handleShow(row)}
                  variant="contained"
                  color="primary"
                >
                  <FaEye size={18} color="8e8d8d" />
                </Button>
              </span>
            </OverlayTrigger>
          )
        } else {
          return row.id
        }
      },
      button: true,
    },
  ];
  console.log(vendas?.data);

  const productsColumns = [
    {
      name: 'QTD',
      selector: (row: any) => row.sale_qty,
    },

    {
      name: 'DESCRIÇÃO',
      selector: (row: any) => row.item_description ?? '---',
    },
    {
      name: 'SUBTOTAL',
      selector: (row: any) =>
        row.unit_sale_value?.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    {
      name: 'TOTAL',
      selector: (row: any) =>
        row.total?.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
  ];

  const footer = (tableList: any) => {
    const net_value = tableList.reduce(
      (acc: any, row: any) => acc + Number(row.net_value),
      0
    );
    const service_value = tableList.reduce(
      (acc: any, row: any) => acc + Number(row.service_value),
      0
    );
    const gross_value = tableList.reduce(
      (acc: any, row: any) => acc + Number(row.gross_value),
      0
    );

    return {
      created_at: "Total",
      net_value,
      service_value,
      gross_value,
    };
  };

  const footerData = footer(vendas?.data ?? []);

  const columnsData = [...vendas?.data ?? [], { ...footerData, isFooter: true }];

  const conditionalRowStyles = [
    {
      when: (tableList: any) => tableList.id === 'Total',
      style: {
        backgroundColor: '#E5E7EB',
        fontWeight: 'bold',
        fontSize: '12px',
        color: 'black',
      },
    },
  ];

  const paginationOptions = {
    rowsPerPageText: 'Registros por página',
    rangeSeparatorText: 'de',
  };

  const fillOperationType = async () => {
    const list = oOperationType.map((item: any) => ({
      value: item.id,
      label: item.value,
    }));
    setListOperationType(list);
  };


  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    //setPerPage(newPerPage);
    setPage(page);
  };



  /*
    const getMovement = (page: number, filter?: string) => {
      const uri =
        filter !== undefined
          ? `${filter}&paginate=false&store_id=${storeMe?.storeActive?.id}`
          : `paginate=false&store_id=${storeMe?.storeActive?.id}`;
      if (page > lastPage) {
        page = lastPage;
      }
      setLoading(true);
      api
        .get(Globals.api.sales + `?${uri}`)
        .then((response) => {
          const data = response.data;
  
          setTableList(data.data);
        })
        .catch((error) => {
          notifyError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    };
  */
  useEffect(() => {
    //getMovement(1);
    fillOperationType();
  }, []);


  return (
    <>
      <LayoutFilter
        title={title}
        // onClickSearch={handleSearchList}
        onClickClear={clearFields}
        onClickOpenFilter={onClickOpenFilter}
        openFilter={openFilter}
      >
        <S.Wrapper>
          {openFilter && (
            <div className="min-screen">
              <ReactSelect
                label="Período"
                placeholder="Período"
                state={type_date}
                options={listdate}
                isInvalid={false}
                setState={setTypeDate}
              />

              <InputDefault
                label="De"
                type="date"
                disabled={type_date === 0}
                state={type_date === 2 ? startDate : movementStartDate}
                onChenge={(e: any) => handleDateStart(e.target.value)}
              />

              <InputDefault
                label="Até"
                type="date"
                disabled={type_date === 0}
                state={movementEndDate}
                onChenge={(e: any) => handleDateEnd(e.target.value)}
              />

              <ReactSelect
                label="Turno"
                state={shift}
                options={listTurn}
                setState={setShift}
              />

              <ReactSelect
                label="Operação"
                placeholder={'Operação'}
                state={operationType}
                options={listOperationType}
                setState={setOperationType}
              />
            </div>
          )}

          <div className="max-screen">
            <ReactSelect
              label="Período"
              state={type_date}
              options={listdate}
              isInvalid={false}
              setState={setTypeDate}
            />

            <InputDefault
              label="De"
              type="date"
              disabled={type_date === 0}
              state={type_date === 2 ? startDate : movementStartDate}
              onChenge={(e: any) => handleDateStart(e.target.value)}
            />

            <InputDefault
              label="Até"
              type="date"
              disabled={type_date === 0}
              state={movementEndDate}
              onChenge={(e: any) => handleDateEnd(e.target.value)}
            />


            <ReactSelect
              label="Turno"
              state={shift}
              options={listTurn}
              setState={setShift}
            />
            <ReactSelect
              label="Operação"
              state={operationType}
              options={listOperationType}
              setState={setOperationType}
            />
          </div>
        </S.Wrapper>
      </LayoutFilter>

      <LayoutTable>
        <DataTable
          columns={columns}
          data={columnsData}
          striped
          pagination
          paginationServer
          paginationTotalRows={vendas?.meta?.total}
          paginationDefaultPage={1}
          paginationPerPage={15}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          customStyles={tableStyleDefault}
          conditionalRowStyles={conditionalRowStyles}
          paginationComponentOptions={paginationOptions}
          progressPending={isLoadingVendas}
          progressComponent={<CustomLoader />}
          noDataComponent="Nenhuma informação foi encontrada."
        />
      </LayoutTable>

      <Modal show={showDetalhe} onHide={handleCloseDetalhe} size="lg" centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1.1rem' }}>
            {vendaDetalhe ? `Venda #${vendaDetalhe.order_number}` : 'Detalhes da Venda'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SaleDetailView
            venda={vendaDetalhe}
            onBack={handleCloseDetalhe}
            loading={loadingDetalhe}
            hideTopBar
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
